import { render } from "./sideBarTwo.vue?vue&type=template&id=42999a74&scoped=true"
import script from "./sideBarTwo.vue?vue&type=script&lang=js"
export * from "./sideBarTwo.vue?vue&type=script&lang=js"

import "./sideBarTwo.vue?vue&type=style&index=0&id=42999a74&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42999a74"]])

export default __exports__